import React from 'react';
import classes from './style.module.css'
import { Button } from 'react-bootstrap';


const ToggleButton = props => {
   return (
       <div className={classes.ToggleButton}>
            <Button size="sm" variant="info" onClick={props.clicked}>{props.label}</Button>
       </div>
   );
}

export default ToggleButton;